import request from '@/modules/base/util/request'
import config from '@/config'
import { sanitizeListColumns } from '@/redux/util/sanitizeListColumns'
import todoConfig from '@/modules/todo/config'
import TodoListColumnModel from '@/modules/todo/components/list/models/todo-list-column-model'
import TodoListModel from '@/modules/todo/components/list/models/todo-list-model'

import {
  updateQuickCounter,
  updatePagination,
  listError,
  settingsError,
  settingsUpdate,
  settingsLoading,
  addItem,
  LIST_TYPES,
  dispatch,
  getList,
  setShallRefresh,
  QUERY_TYPES,
  fetchCounter,
} from '@/redux/ducks/lists'
import { typedUpdateColumnSetting } from './_helpers/typedUpdateColumnSetting'
import store from '@/redux/store'

const { TODO_LIST_TYPE } = LIST_TYPES

export const updateColumnSort = (data) => {
  return (dispatch) => {
    const sendRequest = request(`${todoConfig.todoListSetting}/sort`, {
      auth: true,
      method: 'PUT',
      data: data.filter(item => item.name),
    })

    sendRequest
      .catch((error) => {
        dispatch(settingsError(TODO_LIST_TYPE, error))
      })
  }
}

export const updateColumnSetting = (data, updateFromSettingModal) => {
  return typedUpdateColumnSetting(data, updateFromSettingModal, TODO_LIST_TYPE, todoConfig.todoListSetting, fetchListSetting)
}

export const fetchListSetting = () => {
  const { subscriptions } = store.getState().tenant.info
  const isTaxConsultant = subscriptions?.some(s => s.isTaxConsultant)

  return (dispatch) => {
    dispatch(settingsLoading(TODO_LIST_TYPE))
    request(todoConfig.todoListSetting, { auth: true, isConcurrent: true })
      .then((response) => {
        const {
          body: {
            data: { autoSizeColumns, columns },
            meta: {
              defaultSort,
              sortBy,
            },
          },
        } = response
        const sanitizedColumns = sanitizeListColumns(columns, defaultSort, sortBy)
        const todoColumns = sanitizedColumns.map((column) => {
          column.displayed = true
          if (column.name === 'clientNumber' || column.name === 'clientName') {
            column.displayed = !!isTaxConsultant
            column.hide = !column.displayed
          }
          return new TodoListColumnModel(column)
        })
        dispatch(settingsUpdate(TODO_LIST_TYPE, { autoSizeColumns, columns: todoColumns }))
      })
      .catch((error) => {
        dispatch(settingsError(TODO_LIST_TYPE, error))
      })
  }
}

export const fetchList = (params) => {
  const url = todoConfig.routes.list
  const { searchTerm, quickFilter, filterItems, fetchCounters } = getList(TODO_LIST_TYPE)
  const { request: requestData } = params
  const dataToSend = {
    ...requestData,
    filterModel: { ...requestData.filterModel, ...quickFilter },
    filterItems,
    searchTerm,
    queryType: QUERY_TYPES.DATA,
  }

  return request(url, {
    method: 'POST',
    auth: true,
    isConcurrent: true,
    timeout: config.requestExtraLongTimeout,
    data: dataToSend,
  })
    .then(response => {
      const { data, meta } = response.body
      dispatch(updatePagination(TODO_LIST_TYPE, meta))
      dispatch(updateQuickCounter(TODO_LIST_TYPE, meta))
      const transformed = data.map(item => new TodoListModel(item))
      params.successCallback(transformed, meta.count)
      if (fetchCounters) {
        fetchCounter(TODO_LIST_TYPE, url, dataToSend)
      }
      return { data: transformed, meta }
    })
    .catch((error) => {
      dispatch(listError(TODO_LIST_TYPE, error))
      // ag-grid expects (rowData, lastRow): an empty result ends the loading row and the list shows its no rows overlay.
      // params.fail() would leave the loading row behind without telling the user anything
      params.successCallback([], 0)
      return { data: [], meta: { count: 0 } }
    })
}

export const addListItem = item => {
  return dispatch => {
    dispatch(addItem(TODO_LIST_TYPE, item))
  }
}

export const refreshList = () => {
  return dispatch => {
    dispatch(setShallRefresh(TODO_LIST_TYPE, true))
  }
}
